<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Dedication--Front-Matter-"><span class="sz">To my grandmother</span></p>
<p class="ORIM-Dedication--Front-Matter-"><span class="sz">Annie Asaro</span></p>
<p class="ORIM-Dedication--Front-Matter-"><span class="sz">with love</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?13872efd